import React, { useEffect, useState } from 'react'
import { BlackCustomButton, HeroSection, MarqueeComponentHomePage } from './qbStrap'
import styles from '../styles/newFeature.module.css';
import content from '../language/ENGLISH.json'
import { ClientsArr1, testimonialData, videoTestimonial , getTitleContent } from '@/constants/common';
import Image from 'next/image';
import ThreeStepForm from './common/ThreeStepForm';
import MobileTestimonialSection from './common/MobileTestimonialSection';
import TestimonialSection from './common/TestimonialSection';
import FAQ_mobile from './Industry/FAQ_mobile';
import FrequentQuestions from './homePage/FrequentQuestions';
import MobilePDBanner from './common/MobilePDBanner';
import PersonalisedDemoBanner from './common/PersonalisedDemoBanner';
import VerificationPopup from './modals/VerificationPopup';
import ReactTyped from 'react-typed';
import { useRouter } from 'next/router';

const ERP = () => {
    const { commonMarqueTitle } = getTitleContent();
    const { testimonialHeadText } = content.testimonial;
    const [demoModal, setDemoModal] = useState(false);
    const [formHeading, setHeading] = useState("Book your free demo now!");
    const [mobileView, setmobileView] = useState(0);
    const router = useRouter()

    const setWindowDimensions = () => {
        window.innerWidth > 600 ? setmobileView(0) : setmobileView(1);
    };

    useEffect(() => {
        setWindowDimensions();
        window.addEventListener("resize", setWindowDimensions);
        return () => {
            window.removeEventListener("resize", setWindowDimensions);
        };
    }, []);

    const solutions = [
        {
            id: 0,
            icon: "/assets/features/erp/icon/POS.svg",
            title: "Point of Sale",
            bgColor: "#FFF6E4",
            borderColor: "#F8D378",
            points: [
                {
                    id: 1,
                    title: "Billing",
                    desc: "Efficiently process transactions to reduce wait times and enhance customer satisfaction.",
                },
                {
                    id: 2,
                    title: "CRM & Loyalty",
                    desc: "Manage customer relationships and reward loyalty with personalized marketing and discounts.",
                },
                {
                    id: 3,
                    title: "Easy Return & Exchange",
                    desc: "Simplify return and exchange processes for a hassle-free customer experience.",
                },
                {
                    id: 4,
                    title: "Weight-Scale Integration",
                    desc: "Automatically record and price-weighted items for accurate, efficient billing.",
                },
                {
                    id: 5,
                    title: "Multiple Billing Counters",
                    desc: "Handle high customer volumes effectively with simultaneous transactions across counters.",
                },
                {
                    id: 6,
                    title: "Multiple Payment Modes",
                    desc: "Offer various payment methods for a seamless and flexible checkout experience.",
                },
                {
                    id: 7,
                    title: "Cash Drawer Integration",
                    desc: "Streamline cash transactions with secure and organized cash drawer management.",
                }
            ]
        },
        {
            id: 1,
            icon: "/assets/features/erp/icon/procurement.svg",
            title: "Procurement",
            bgColor: "#FFF3F3",
            borderColor: "#FFC3C3",
            points: [
                {
                    id: 1,
                    title: "Purchase Order Mapping",
                    desc: "Easily track and manage purchase orders from creation to fulfillment."
                },
                {
                    id: 2,
                    title: "Supplier Management",
                    desc: "Maintain and optimize supplier relationships for better pricing and service."
                },
                {
                    id: 3,
                    title: 'Expenditure Analysis',
                    desc: "Analyze spending patterns to identify cost-saving opportunities and improve budgeting."

                },
                {
                    id: 4,
                    title: "Advanced Account Payables",
                    desc: "Efficiently manage and automate accounts payable for accurate and timely payments."
                }
            ]
        },
        {
            id: 2,
            icon: "/assets/features/erp/icon/inventory.svg",
            title: "Inventory Management",
            bgColor: "#EDFBFE",
            borderColor: "#C9F6FF",
            points: [
                {
                    id: 1,
                    title: "Manage Multiple Pricing",
                    desc: "Easily handle various pricing strategies for different products and customer segments."
                },
                {
                    id: 2,
                    title: "Manage Multiple Product",
                    desc: "Efficiently organize and manage a diverse range of products in your inventory."
                },
                {
                    id: 3,
                    title: "Generate Labels & Barcode",
                    desc: "Quickly create and print labels and barcodes for accurate product tracking."
                },
                {
                    id: 4,
                    title: "Stock Alerts",
                    desc: "Receive notifications when stock levels are low to prevent shortages."
                },
                {
                    id: 5,
                    title: "Import Products from Excel Sheet",
                    desc: "Simplify inventory setup by importing product data directly from Excel sheets."
                },
            ]
        },
        {
            id: 3,
            icon: "/assets/features/erp/icon/estore.svg",
            title: "Sell In Store / Online",
            bgColor: "#FCF7FF",
            borderColor: "#EEC9FF",
            points: [
                {
                    id: 1,
                    title: "Sell In-Store/Online",
                    desc: "Seamlessly manage sales both in-store and online for a unified shopping experience."
                },
                {
                    id: 2,
                    title: "Easy Unicommerce Integration",
                    desc: "Integrate effortlessly with Unicommerce for streamlined inventory and order management."
                },
                {
                    id: 3,
                    title: "Get Free eStore",
                    desc: "Launch a free online store to expand your business presence and reach more customers."
                },
                {
                    id: 4,
                    title: "Multiple Payment Integration",
                    desc: "Support various payment methods to provide a flexible and convenient checkout experience."
                },
                {
                    id: 5,
                    title: "Order Management (Single Dashboard)",
                    desc: "Manage all orders from a single dashboard for efficient and centralized control."
                },
            ]
        },
        {
            id: 4,
            icon: "/assets/features/erp/icon/multi-location.svg",
            title: "Multi Location / Franchise Management",
            bgColor: "#EDFEF9",
            borderColor: "#87F1D5",
            points: [
                {
                    id: 1,
                    title: "Multi-Store Management",
                    desc: "Oversee and coordinate activities across various stores seamlessly."
                },
                {
                    id: 2,
                    title: "Easy Stock Transfer",
                    desc: "Facilitate smooth and quick stock transfers between different locations."
                },
                {
                    id: 3,
                    title: "Sales & Purchase Tracking",
                    desc: "Track sales and purchases accurately across all locations."
                },
                {
                    id: 4,
                    title: "Centralized Reporting",
                    desc: "Generate comprehensive reports from a centralized system for better decision-making."
                },
            ]
        },
        {
            id: 5,
            icon: "/assets/features/erp/icon/omnichannel.svg",
            title: "Omnichannel Management",
            bgColor: "#FFF6E4",
            borderColor: "#F8D378",
            points: [
                {
                    id: 1,
                    title: "CRM & Loyalty",
                    desc: "Enhance customer relationships and loyalty programs across all sales channels."
                },
                {
                    id: 2,
                    title: "Free eStore Link",
                    desc: "Easily connect your free eStore with other sales channels for unified management."
                },
                {
                    id: 3,
                    title: "Managed from Mobile App",
                    desc: "Conveniently manage all operations and channels directly from a mobile app."
                },
            ]
        },
        {
            id: 6,
            icon: "/assets/features/erp/icon/custom-reporting.svg",
            title: "Accounting & Custome Reporting",
            bgColor: "#FCF7FF",
            borderColor: "#EEC9FF",
            points: [
                {
                    id: 1,
                    title: "eWay Billing",
                    desc: "Generate and manage eWay bills effortlessly for smooth transportation compliance."
                },
                {
                    id: 2,
                    title: "e-Invoicing",
                    desc: "Streamline invoicing processes with electronic invoicing for accuracy and efficiency."
                },
                {
                    id: 3,
                    title: "ADS Report",
                    desc: "Access comprehensive Automated Data Summarization (ADS) reports for insightful analysis."
                },
                {
                    id: 4,
                    title: "GST Filing Integration",
                    desc: "Simplify tax compliance with seamless GST filing integration."
                },
            ]
        },
    ]

    const erpBenefits = [
        {
            id: 1,
            title: "Real-Time Financial Insights",
            desc: "Gain immediate access to detailed financial reports and analytics, empowering informed decision-making and strategic planning.",
            icon: "/assets/features/erp/erp-benefits/real-time.svg",
        },
        {
            id: 2,
            title: "Enhanced Compliance Management",
            desc: "Ensure full compliance with the latest GST regulations through automated updates and comprehensive compliance tracking.",
            icon: "/assets/features/erp/erp-benefits/policy-privacy.svg",
        },
        {
            id: 3,
            title: "Scalable and Customizable Solutions",
            desc: "Tailor the ERP system to fit your business growth and unique requirements, providing a flexible solution that evolves with your organization.",
            icon: "/assets/features/erp/erp-benefits/scalable.svg",
        },
        {
            id: 4,
            title: "Streamlined Procurement Process",
            desc: "Automate procurement workflows to improve efficiency, reduce errors, and control costs.",
            icon: "/assets/features/erp/erp-benefits/streamlined.svg",
        },
        {
            id: 5,
            title: "Improved Cash Flow Management",
            desc: "Optimize cash flow with real-time visibility into accounts receivable and payable, ensuring better liquidity management.",
            icon: "/assets/features/erp/erp-benefits/cash-flow.svg",
        },
        {
            id: 6,
            title: "Advanced-Data Security",
            desc: "Protect sensitive business data with robust security measures and regular backups, ensuring data integrity and confidentiality.",
            icon: "/assets/features/erp/erp-benefits/data-security.svg",
        },

    ]

    const publicSector = [
        {
            id: 1,
            image: "/assets/features/erp/public-sectors/Asset 1.webp",
            altText: "Tirumala Tirupati Devasthanams",
            height: "10rem",
            width: "20rem",
            mobHeight: "7rem",
            mobWidth: "14rem",
        },
        {
            id: 2,
            image: "/assets/features/erp/public-sectors/Asset 2.webp",
            altText: "Sabrimala sree Dharma Sastha Annadhana Trust",
            height: "8rem",
            width: "20rem",
            mobHeight: "6rem",
            mobWidth: "15rem",
        },
        {
            id: 3,
            image: "/assets/features/erp/public-sectors/Asset 3.webp",
            altText: "Travanacore Devaswom Board",
            height: "10rem",
            width: "20rem",
            mobHeight: "7rem",
            mobWidth: "14rem",
        },
        {
            id: 4,
            image: "/assets/features/erp/public-sectors/Asset 4.webp",
            altText: "shree siddhivinayak",
            height: "12rem",
            width: "12rem",
            mobHeight: "10rem",
            mobWidth: "10rem",
        },
        {
            id: 5,
            image: "/assets/features/erp/public-sectors/Asset 5.webp",
            altText: "isha foundation",
            height: "10rem",
            width: "13rem",
            mobHeight: "7rem",
            mobWidth: "10rem",
        },
        {
            id: 6,
            image: "/assets/features/erp/public-sectors/Asset 6.webp",
            altText: "power corporation limited",
            height: "10rem",
            width: "10rem",
            mobHeight: "8rem",
            mobWidth: "8rem",
        },
        {
            id: 7,
            image: "/assets/features/erp/public-sectors/Asset 7.webp",
            altText: "jhansi smart city",
            height: "8rem",
            width: "15rem",
            mobHeight: "7rem",
            mobWidth: "14rem",
        },
        {
            id: 8,
            image: "/assets/features/erp/public-sectors/Asset 8.webp",
            altText: "radius",
            height: "5rem",
            width: "15rem",
            mobHeight: "5rem",
            mobWidth: "14rem",
        },
        {
            id: 9,
            image: "/assets/features/erp/public-sectors/Asset 9.webp",
            altText: "BSES",
            height: "5rem",
            width: "15rem",
            mobHeight: "5rem",
            mobWidth: "14rem",
        },
        {
            id: 10,
            image: "/assets/features/erp/public-sectors/Asset 10.webp",
            altText: "agra vikas pradhikaran",
            height: "12rem",
            width: "15rem",
            mobHeight: "7rem",
            mobWidth: "11rem",
        },
        {
            id: 11,
            image: "/assets/features/erp/public-sectors/Asset 11.webp",
            altText: "IRCTC",
            height: "5rem",
            width: "15rem",
            mobHeight: "4rem",
            mobWidth: "13rem",
        },
        {
            id: 12,
            image: "/assets/features/erp/public-sectors/Asset 12.webp",
            altText: "national food security",
            height: "12rem",
            width: "12rem",
            mobHeight: "10rem",
            mobWidth: "10rem",
        },
        {
            id: 13,
            image: "/assets/features/erp/public-sectors/Asset 13.webp",
            altText: "Uttar Pradesh Government",
            height: "12rem",
            width: "15rem",
            mobHeight: "10rem",
            mobWidth: "13rem",
        },
        {
            id: 14,
            image: "/assets/features/erp/public-sectors/Asset 14.webp",
            altText: "coromandel",
            height: "6rem",
            width: "15rem",
            mobHeight: "5rem",
            mobWidth: "13rem",
        },
        {
            id: 15,
            image: "/assets/features/erp/public-sectors/Asset 15.webp",
            altText: "sri sri tattva",
            height: "6rem",
            width: "14rem",
            mobHeight: "7rem",
            mobWidth: "14rem",
        },
    ]

    const erpSoftware = [
        {
            id: 1,
            title: "Cloud Storage for Entrepreneurs: Scaling Your Business with Confidence",
            desc: "Discover cost-effective storage options, scalability features, and success stories from entrepreneurs who have leveraged cloud storage.",
            logo: "/assets/MICROSOFT DYNAMICS.webp",
            bgColor: "#EDFBFE",
            height: "6rem",
            width: "20rem"
        },
        {
            id: 2,
            title: "Cloud Storage for Entrepreneurs: Scaling Your Business with Confidence",
            desc: "Discover cost-effective storage options, scalability features, and success stories from entrepreneurs who have leveraged cloud storage.",
            logo: "/assets/ZOHO.webp",
            bgColor: "#FFF3F3",
            height: "7rem",
            width: "17rem"
        },
        {
            id: 3,
            title: "Cloud Storage for Entrepreneurs: Scaling Your Business with Confidence",
            desc: "Discover cost-effective storage options, scalability features, and success stories from entrepreneurs who have leveraged cloud storage.",
            logo: "/assets/oracle.webp",
            bgColor: "#FFF6E4",
            height: "6rem",
            width: "15rem"
        },
        {
            id: 4,
            title: "Cloud Storage for Entrepreneurs: Scaling Your Business with Confidence",
            desc: "Discover cost-effective storage options, scalability features, and success stories from entrepreneurs who have leveraged cloud storage.",
            logo: "/assets/SAP_img.webp",
            bgColor: "#FCF7FF",
            height: "5rem",
            width: "14rem"
        },
    ]
    const erpSystem = [
        {
            id: 1,
            desc: "Research and compare an ideal ERP software necessary for your business type",
            image: "/assets/features/erp/erp-system/evaluate.svg",
        },
        {
            id: 2,
            desc: "Plan budgeting and resources for buying a subscription",
            image: "/assets/features/erp/erp-system/plan.svg",
            left: "-2%",
        },
        {
            id: 3,
            desc: "Consider prioritizing your ERP initialization along with all the features required.",
            image: "/assets/features/erp/erp-system/consider.svg",
            left: "-4%",
        },
        {
            id: 4,
            desc: "Choose the perfect fit and transition your business into an ERP-managed entity.",
            image: "/assets/features/erp/erp-system/choose.svg",
            left: "-6%",
        }

    ]

    const faqs = [
        {
            para: (
                <span style={{ width: "90%" }}>
                    What ERP software mean?
                </span>
            ),
            des: "ERP stands for Enterprise Resource Planning. It refers to a suite of integrated software applications that businesses use to manage and automate various back-office functions, including accounting, finance, human resources, supply chain management, inventory management, and more. ERP software streamlines business processes enhance efficiency and provides real-time data insights for informed decision-making.",
            id: 1,
            activeIndex: 1,
        },
        {
            para: (
                <span style={{ width: "90%" }}>
                    Is ERP a software or tool?
                </span>
            ),
            des: "ERP is a type of software solution rather than a single tool. It encompasses a range of applications and modules designed to handle different aspects of business operations. These software solutions are integrated to provide a centralized and comprehensive platform for managing resources, processes, and data across an organization.",
            id: 2,
            activeIndex: 2,
        },
        {
            para: (
                <span style={{ width: "90%" }}>
                    What is an example of ERP software?
                </span>
            ),
            des: "Some examples of popular ERP software solutions include SAP ERP, QueueBuster, Oracle ERP Cloud, Microsoft Dynamics 365, NetSuite, and Infor ERP. These systems offer a wide range of functionalities tailored to different industries and business sizes.",
            id: 3,
            activeIndex: 3,
        },
        {
            para: (
                <span style={{ width: "90%" }}>
                    What is ERP in billing?
                </span>
            ),
            des: "ERP in billing refers to the billing and invoicing capabilities integrated into an ERP system. This functionality allows businesses to create, manage, and process invoices, track payments, manage billing cycles, and handle other financial transactions seamlessly within the ERP environment.",
            id: 4,
            activeIndex: 4,
        },
        {
            para: (
                <span style={{ width: "90%" }}>
                    What is CRM in POS?
                </span>
            ),
            des: "CRM (Customer Relationship Management) in POS (Point of Sale) refers to integrating CRM functionalities into a POS system. It enables businesses to manage customer interactions, track customer preferences and purchase history, offer personalized promotions and loyalty programs, and enhance overall customer experience directly from the POS interface.",
            id: 5,
            activeIndex: 5,
        },
        {
            para: (
                <span style={{ width: "90%" }}>
                    Is Oracle a POS system?
                </span>
            ),
            des: "Oracle offers a range of business management solutions, including ERP systems, CRM software, and POS systems. While Oracle does provide POS solutions, it is better known for its ERP and CRM offerings, such as Oracle ERP Cloud and Oracle CX Cloud Suite.",
            id: 6,
            activeIndex: 6,
        },
        {
            para: (
                <span style={{ width: "90%" }}>
                    What is ERP and MRP software?
                </span>
            ),
            des: "ERP (Enterprise Resource Planning) software integrates various business functions across an organization, including manufacturing resource planning (MRP) modules. MRP software focuses specifically on manufacturing processes, helping businesses plan and manage production schedules, inventory levels, material requirements, and supply chain operations.",
            id: 7,
            activeIndex: 7,
        },
        {
            para: (
                <span style={{ width: "90%" }}>
                    What is total ERP software?
                </span>
            ),
            des: "Total ERP software refers to a comprehensive ERP solution that covers all essential business functions and processes within an organization. It includes modules for finance, HR, supply chain management, manufacturing, inventory management, CRM, and more, providing a complete suite of tools for managing and optimizing business operations.",
            id: 8,
            activeIndex: 8,
        },
        {
            para: (
                <span style={{ width: "90%" }}>
                    Is POS Software?
                </span>
            ),
            des: "Yes, POS (Point of Sale) is a type of software used by businesses to facilitate transactions, manage sales, process payments, track inventory, and generate reports. It is a critical tool for retail and hospitality businesses, helping them streamline operations and provide efficient customer service.",
            id: 9,
            activeIndex: 9,
        },
        {
            para: (
                <span style={{ width: "90%" }}>
                    What is the ERP system in the store?
                </span>
            ),
            des: "The ERP system in a store refers to the ERP software used to manage various store operations, including inventory management, sales and purchases, customer management, financial transactions, and reporting. It provides a centralized platform for store managers to oversee and control activities effectively.",
            id: 10,
            activeIndex: 10,
        },
        {
            para: (
                <span style={{ width: "90%" }}>
                    What is POS or SAP?
                </span>
            ),
            des: "POS (Point of Sale) and SAP (Systems, Applications, and Products) are different types of software solutions used in business management. POS software is primarily focused on managing sales transactions, inventory, and customer interactions at the point of sale, typically in retail or hospitality settings. SAP, on the other hand, is an ERP software suite that encompasses a broader range of functionalities, including financial management, supply chain management, HR management, and more. While POS systems and SAP ERP can integrate, they serve different purposes within an organization's technology stack.",
            id: 11,
            activeIndex: 11,
        },
    ]


    const [selectedSolutins, setSelectedSolutions] = useState({ title: 'Point of Sale', points: solutions[0].points, bgColor: "#fff6e4", borderColor: "#F8D378" })
    const [readMore, setReadMore] = useState(false)
    const [heroReadMore, setHeroReadMore] = useState(false);

    return (
        <>
        <div className={styles.verificationPopupOverride}>
            <VerificationPopup isOpen={demoModal} closeModal={() => setDemoModal(false)} formHeading={formHeading} />
           </div>
            {
                mobileView ?
                    <div className={styles.erp_hero_section} style={{ backgroundImage: "url('/assets/features/erp/mobile-hero-img.webp')" }}>
                        <div>
                            <h1>
                                <span>A Cloud-Based ERP Software For</span><br />
                                <span><ReactTyped strings={["Retail", "Supermarkets", "Multi-Store Business", "Franchises", "Manufacturers", "Distributors"]} typeSpeed={200} loop /></span>
                            </h1>
                            <p style={{ maxHeight: heroReadMore ? "20rem" : "5rem", overflow: heroReadMore ? 'auto' : "hidden", transition: "1s", marginTop: "2rem" }}>Whether it's your first time adopting a multi-industry ERP software or migrating from an existing one to the cloud, you can now access a complete, modular solution with analytics capabilities to drive your business forward with QueueBuster ERP Software.</p>
                            <p className={styles.read_more} onClick={() => setHeroReadMore(!heroReadMore)}>{heroReadMore ? "Read Less" : "Read More"}</p>
                            <div className={styles.btn_container}>
                                <button className={styles.solid_btn} onClick={() => setDemoModal(true)}>Try It Free</button>
                                <button className={styles.border_btn} onClick={() => router.push("/contact-form")}>Contact Sales</button>
                            </div>
                        </div>
                    </div>
                    :
                    <div className={styles.sections}>
                        <HeroSection
                            backgroundImg="/assets/features/erp/background-image.webp"
                            image={"/assets/features/erp/hero-img.webp"}
                            imageStyle={{ height: "33rem", width: "55rem", position: "absolute", bottom: "-4rem", right: "-6rem" }}
                            card1={"/assets/features/erp/hero-img-card1.webp"}
                            card1Style={{ height: "19rem", width: "24rem", position: "absolute", bottom: "11rem", left: "0rem" }}
                            card2={"/assets/features/erp/hero-img-card2.webp"}
                            card2Style={{ height: "16rem", width: "28rem", position: "absolute", top: "10rem", right: "-2rem" }}
                            heading={"A Cloud-Based ERP Software For"}
                            typedHeading={["Retail", "Supermarkets", "Multi-Store Business", "Franchises", "Manufacturers", "Distributors"]}
                            description={"Whether it's your first time adopting a multi-industry ERP software or migrating from an existing one to the cloud, you can now access a complete, modular solution with analytics capabilities to drive your business forward with QueueBuster ERP Software."}
                            outlinedBtn={true}
                        />
                    </div>
            }
            <div className={styles.marquee_section}>
                <div className={styles.section_heading}><h3>{commonMarqueTitle}</h3><div className={styles.heading_stroke} style={{ width: '22rem' }}><Image src='/assets/industry/restaurant/features_hl.svg' alt='stroke' fill /></div></div>
                <MarqueeComponentHomePage ClientsArr={ClientsArr1} />
            </div>
            <div className={`${styles.sections} ${styles.secure_solutions}`}>
                <div className={styles.section_heading}><h3>Reliable, fast & Secure Solutions (TBD)</h3><div className={styles.heading_stroke} style={{ width: '22rem' }}><Image src='/assets/industry/restaurant/features_hl.svg' alt='stroke' fill /></div></div>

                {
                    mobileView ?
                        <div>
                            {
                                solutions?.map((ele) => {
                                    return (
                                        <div style={{ backgroundColor: selectedSolutins?.title === ele?.title ? ele?.bgColor : "#fff", padding: "2rem", borderRadius: "6px" }}>
                                            <div style={{ display: "flex", gap: "1rem", alignItems: "center", marginBottom: "2rem" }} key={ele?.id} onClick={() => setSelectedSolutions({ title: ele?.title, points: solutions[ele?.id].points, bgColor: ele?.bgColor, borderColor: ele?.borderColor })}>
                                                <div style={{ height: "3rem", width: "3rem", position: "relative" }}><Image src={ele?.icon} alt={ele?.title} fill /></div>
                                                <p style={{ fontWeight: Boolean(selectedSolutins?.title === ele?.title) && 600, marginBottom: "0" }}>{ele?.title}</p>
                                            </div>
                                            {
                                                (selectedSolutins?.title === ele?.title) &&
                                                ele?.points?.map((ele) => {
                                                    return (
                                                        <div style={{ borderLeft: `3px solid ${selectedSolutins?.borderColor}`, paddingLeft: "1rem", marginBottom: "2rem" }}>
                                                            <h4 style={{ font: "normal normal 600 1.6rem/2rem Inter" }}>{ele?.title}</h4>
                                                            <p>{ele?.desc}</p>
                                                        </div>
                                                    )
                                                })

                                            }
                                        </div>
                                    )
                                })
                            }
                        </div>
                        :
                        <div>
                            <div className={styles.secure_solution_left}>
                                {
                                    solutions?.map((ele) => {
                                        return (
                                            <div key={ele?.id} style={{ backgroundColor: selectedSolutins?.title === ele?.title ? ele?.bgColor : "#fff", borderLeft: Boolean(selectedSolutins?.title === ele?.title) && `2px solid ${ele?.borderColor}` }} onClick={() => setSelectedSolutions({ title: ele?.title, points: solutions[ele?.id].points, bgColor: ele?.bgColor, borderColor: ele?.borderColor })}>
                                                <div><Image src={ele?.icon} alt={ele?.title} fill /></div>
                                                <p style={{ fontWeight: Boolean(selectedSolutins?.title === ele?.title) && 600 }}>{ele?.title}</p>
                                            </div>
                                        )
                                    })
                                }
                            </div>
                            <div style={{ backgroundColor: selectedSolutins?.bgColor }} className={styles.secure_solution_right}>
                                <div>
                                    {
                                        selectedSolutins?.points?.map((ele) => {
                                            return (
                                                <div style={{ borderLeft: `3px solid ${selectedSolutins?.borderColor}` }}>
                                                    <h4>{ele?.title}</h4>
                                                    <p>{ele?.desc}</p>
                                                </div>
                                            )
                                        })
                                    }
                                </div>
                            </div>
                        </div>
                }
            </div>
            <div className={`${styles.sections} ${styles.erp_benefits}`} >
                <div className={styles.section_heading}><h3 style={{ color: "#fff" }}>Benefits of QB ERP System</h3><div className={styles.heading_stroke} style={{ width: '22rem' }}><Image src='/assets/industry/restaurant/features_hl.svg' alt='stroke' fill /></div></div>
                <p>Level up your profits with an end-to-end storefront solution tailored to suit any retail business across multiple industries. Get details of
                    what the QueueBuster POS system is capable of to expand your business.</p>

                <div className={styles.box_container}>
                    {
                        erpBenefits?.map((ele) => {
                            return (
                                <div>
                                    <div><Image src={ele?.icon} alt={ele?.title} fill /></div>
                                    <h4>{ele?.title}</h4>
                                    <p>{ele?.desc}</p>
                                </div>
                            )
                        })
                    }
                </div>
            </div>
            <div className={styles.sections}>
                <div className={styles.section_heading}><h3>Enterprise Solutions for Public Sector</h3><div className={styles.heading_stroke} style={{ width: '22rem' }}><Image src='/assets/industry/restaurant/features_hl.svg' alt='stroke' fill /></div></div>
                <p style={{ textAlign: "center" }}>Level up your profits with an end-to-end storefront solution tailored to suit any retail business across multiple industries. Get details of what the QueueBuster POS system is capable of to expand your business.</p>
                <div style={{ padding: mobileView ? "4rem 1rem" : "4rem 3rem", borderRadius: "10px", display: "flex", flexWrap: "wrap", gap: mobileView ? "3rem" : "5rem", justifyContent: "center", alignItems: "center", height: mobileView ? "50rem" : "fit-content", overflowY: mobileView ? "scroll" : "auto" }}>
                    {
                        publicSector?.map((ele) => {
                            return (
                                <div key={ele?.id} style={{ height: mobileView ? ele?.mobHeight : ele?.height, width: mobileView ? ele?.mobWidth : ele?.width, position: "relative" }}><Image src={ele?.image} alt={ele?.altText} fill /></div>
                            )
                        })
                    }
                </div>
            </div>
            <div className={styles.sections}>
                <div className={styles.section_heading}><h3>Futuristic Integrations with leading ERP Software</h3><div className={styles.heading_stroke} style={{ width: '22rem' }}><Image src='/assets/industry/restaurant/features_hl.svg' alt='stroke' fill /></div></div>
                <div className={styles.erp_software}>
                    {
                        erpSoftware?.map((ele) => {
                            return (
                                <div key={ele?.id} style={{ backgroundColor: ele?.bgColor }}>
                                    <div style={{ height: ele?.height, width: ele?.width }}><Image src={ele?.logo} alt={ele?.title} fill /></div>
                                    <h4>{ele?.title}</h4>
                                    <p>{ele?.desc}</p>
                                </div>
                            )
                        })
                    }
                </div>
            </div>
            <div className={styles.sections}>
                <div className={styles.section_heading}><h3>How to Choose an ERP System?</h3><div className={styles.heading_stroke} style={{ width: '22rem' }}><Image src='/assets/industry/restaurant/features_hl.svg' alt='stroke' fill /></div></div>
                <div className={styles.erp_system}>
                    {
                        erpSystem?.map((ele) => {
                            return (
                                <div key={ele?.id} style={{ left: ele?.left }} >
                                    <p>{ele?.desc}</p>
                                    <div><Image src={ele?.image} alt={ele?.desc} fill /></div>
                                </div>
                            )
                        })
                    }
                </div>
                <BlackCustomButton text="Get a free consultation" style={{ padding: "0 2rem", margin: "5rem auto", display: "block" }} />
            </div>
            <div className={`${styles.sections} ${styles.cloud_based_erp}`}>
                <div>
                    <h3>Why is QueueBuster the best cloud-based ERP solution?</h3>
                    <ul style={{ maxHeight: readMore ? "200rem" : "30rem", overflow: readMore ? 'auto' : "hidden" }}>
                        <li><b>User-Friendly Interface: </b>QueueBuster's mobile ERP solution features an intuitive and user-friendly interface, making it easy for users at all levels of the organization to navigate and utilize the system effectively. This simplicity enhances user adoption and productivity.</li>
                        <li><b>Scalability:</b> Whether a small startup or a large enterprise, QueueBuster's mobile ERP solution is designed to scale according to business needs. It can accommodate growth, expansion into new markets, and increased transaction volumes without compromising performance or functionality.</li>
                        <li><b>Customization and Integration:</b> QueueBuster offers customization options to tailor the ERP solution to specific business requirements. Additionally, it seamlessly integrates with other software systems and third-party applications, enhancing interoperability and data exchange across the organization.</li>
                        <li><b>Cost-Effective Solution:</b> QueueBuster provides a cost-effective ERP solution compared to traditional on-premise systems. With cloud-based deployment options, businesses can benefit from reduced upfront costs, lower maintenance expenses, and flexible pricing models based on usage or subscription.</li>
                        <li><b>Exceptional Support and Training:</b> QueueBuster offers dedicated support and training resources to help businesses maximize the value of their mobile ERP solution. From implementation assistance to ongoing technical support and training sessions, QueueBuster ensures a smooth and successful experience for its users.</li>
                    </ul>
                    <p style={{ textDecoration: "underline" }} onClick={() => { setReadMore(!readMore) }}>{readMore ? "Read Less" : "Read More"}</p>
                </div>
                {
                    Boolean(!mobileView) && <div><Image src="/assets/features/erp/mc11.webp" alt="cloud based erp solution" fill /></div>
                }

            </div>
            <div className={styles.three_step_form}>
                <ThreeStepForm mobileView={mobileView} />
            </div>

            <div className={styles.testimonial_section}>
                <div className={styles.section_heading}><h3>{testimonialHeadText}</h3> <div className={styles.heading_stroke}><Image src='/assets/strokes_svg/testimonials_hl.svg' alt='industries' fill /></div></div>
                {
                    mobileView ? <MobileTestimonialSection testimonialData={testimonialData} videoTestimonial={videoTestimonial} /> :
                        <TestimonialSection testimonialData={testimonialData} videoTestimonial={videoTestimonial} />
                }
            </div>

            <div style={{ marginTop: "6rem" }}>
                {
                    mobileView ?
                        <FAQ_mobile FaqTableData={faqs} width={"auto"} heading={"FAQs of ERP"} />
                        :
                        <FrequentQuestions FaqTableData={faqs} heading={"FAQs of ERP"} />
                }
            </div>

            <div className={styles.demo_banner_section}>
                {
                    mobileView ? <MobilePDBanner setDemoModal={setDemoModal} setHeading={setHeading} /> : <PersonalisedDemoBanner setDemoModal={setDemoModal} setHeading={setHeading} />
                }
            </div>
        </>
    )
}

export default ERP